import { computed, defineComponent, ref, getCurrentInstance } from "vue";
import ModelColorPicker from "@/views/creative/model-editor/model-color-picker.vue";
import FormPanel from "@/views/creative/components/form-panel.vue";
import ShaderForm from "@/views/creative/model-editor/shader-form.vue";
import { useModelStore } from "@/views/creative/model-editor/model-mixin";
import { language } from "@/common/storage";
import ResetResource from "@/views/creative/components/reset-resource.vue";
import ResetColor from "@/views/creative/model-editor/reset-color.vue";
export default defineComponent({
    components: {
        ResetColor: ResetColor,
        ResetResource: ResetResource,
        FormPanel: FormPanel,
        ModelColorPicker: ModelColorPicker,
        ShaderForm: ShaderForm
    },
    setup: function setup(props) {
        var instance = getCurrentInstance();
        var root = instance === null || instance === void 0 ? void 0 : instance.proxy;
        var store = root.$store;
        var _$ref8 = useModelStore(store), targetModelMaterial = _$ref8.targetModelMaterial, hsvModel = _$ref8.hsvModel, modelMaterialList = _$ref8.modelMaterialList;
        var activeNames = ref([]);
        var handleChange = function(value) {
            activeNames.value = value;
        };
        var hsvValue = computed(function() {
            return store.state.creative.modelEditor.hsvValue;
        });
        var appearanceList = [
            {
                title: root.$t("playTurbo.custom.modelEdit.appearance.partsTitle")
            },
            {
                title: root.$t("playTurbo.custom.modelEdit.appearance.paramTitle")
            }, 
        ];
        var hsvList = computed(function() {
            var _$ref, _$ref1, _$ref2, _$ref3, _$ref4, _$ref5, _$ref6, _$ref7;
            return [
                {
                    title: language.get() === "en" ? (_$ref = targetModelMaterial.value) === null || _$ref === void 0 ? void 0 : _$ref.part_one_name_en : (_$ref1 = targetModelMaterial.value) === null || _$ref1 === void 0 ? void 0 : _$ref1.part_one_name,
                    disabled: hsvModel.value[0].disabled
                },
                {
                    title: language.get() === "en" ? (_$ref2 = targetModelMaterial.value) === null || _$ref2 === void 0 ? void 0 : _$ref2.part_two_name_en : (_$ref3 = targetModelMaterial.value) === null || _$ref3 === void 0 ? void 0 : _$ref3.part_two_name,
                    disabled: hsvModel.value[1].disabled
                },
                {
                    title: language.get() === "en" ? (_$ref4 = targetModelMaterial.value) === null || _$ref4 === void 0 ? void 0 : _$ref4.part_three_name_en : (_$ref5 = targetModelMaterial.value) === null || _$ref5 === void 0 ? void 0 : _$ref5.part_three_name,
                    disabled: hsvModel.value[2].disabled
                },
                {
                    title: language.get() === "en" ? (_$ref6 = targetModelMaterial.value) === null || _$ref6 === void 0 ? void 0 : _$ref6.part_four_name_en : (_$ref7 = targetModelMaterial.value) === null || _$ref7 === void 0 ? void 0 : _$ref7.part_four_name,
                    disabled: hsvModel.value[3].disabled
                }, 
            ];
        });
        var handleReset = function(params) {
            store.commit("creative/modelEditor/resetHsvModelByIndex", params.index);
        };
        var handleResetColor = function(params) {
            console.log("\u91CD\u7F6E\u989C\u8272");
            store.commit("creative/modelEditor/resetHsvModelToNativeByIndex", params.index);
        };
        return {
            activeNames: activeNames,
            handleChange: handleChange,
            hsvList: hsvList,
            hsvModel: hsvModel,
            appearanceList: appearanceList,
            handleReset: handleReset,
            hsvValue: hsvValue,
            targetModelMaterial: targetModelMaterial,
            modelMaterialList: modelMaterialList,
            handleResetColor: handleResetColor
        };
    }
});
